const KEY_REDIRECCION = 'redireccion_pendiente'

// Solo rutas internas del módulo: evita redirigir a URLs arbitrarias que vengan en el link.
const esRutaValida = (ruta: unknown): ruta is string =>
  typeof ruta === 'string' && ruta.startsWith('/tools/')

export function guardarRedireccion(ruta: unknown): void {
  if (!esRutaValida(ruta)) return
  try {
    sessionStorage.setItem(KEY_REDIRECCION, ruta)
  } catch { }
}

export function consumirRedireccion(): string | null {
  try {
    const ruta = sessionStorage.getItem(KEY_REDIRECCION)
    sessionStorage.removeItem(KEY_REDIRECCION)
    return esRutaValida(ruta) ? ruta : null
  } catch {
    return null
  }
}

/** Acepta base64url: un "/" del base64 estándar partiría el segmento :usersesion de la ruta. */
export function decodificarUsersesion(usersesion: string): any {
  return JSON.parse(atob(usersesion.replace(/-/g, '+').replace(/_/g, '/')))
}

/** Las otras apps del ERP abren /login/:usersesion con un JSON en base64; `redirect` es opcional. */
export function redireccionDesdeUsersesion(usersesion: string | null | undefined): string | null {
  if (!usersesion) return null
  try {
    const { redirect } = decodificarUsersesion(usersesion)
    return esRutaValida(redirect) ? redirect : null
  } catch {
    return null
  }
}
